import { BasicTenant } from 'graphql/generated/graphqlTypes';
import { currentTenantVar } from 'state/vars';

export const setCurrentTenantAction = (tenant: BasicTenant) => {
  currentTenantVar(tenant);
};
